import * as palette from "./palette";

import { css } from "@emotion/css";

const ParagraphStyle = css({
  fontSize: "20px",
  lineHeight: "34px",
  marginTop: 25,
  "&:first-of-type": {
    marginTop: 0,
  },
});

const ResetHeadingStyle = css({
  margin: 0,
  padding: 0,
});

const PlaceholderStyle = css({
  "& .public-DraftEditorPlaceholder-root": {
    fontSize: 18,
    color: palette.sealBlue,
    fontWeight: "normal",
    position: "absolute",
  },
});

const FigureResetStyle = css({
  "& figure": {
    margin: 0,
  },

  "& figure > hr": {
    marginTop: 30,
    marginBottom: 30,
  },
});

const BlockquoteStyle = css({
  fontSize: "22px",
  color: "#086BE5",
  "@media (max-width: 767px)": {
    margin: "35px 0px 35px 30px !important",
  },
  "@media (min-width: 767px)": {
    margin: "35px 0px 35px 60px !important",
  },
});

const H3Style = css({
  fontWeight: 600,
  fontSize: "32px !important",
  marginTop: "50px !important",
  marginBottom: "0px !important",
});

const H4Style = css({
  fontWeight: 700,
  fontSize: "24px !important",
  marginTop: "30px !important",
});

const H3H4ParagraphStyle = css({
  [`.${H3Style} + .${H4Style}`]: {
    marginTop: 30,
  },
});

export {
  PlaceholderStyle,
  ParagraphStyle,
  H3H4ParagraphStyle,
  ResetHeadingStyle,
  H3Style,
  H4Style,
  BlockquoteStyle,
  FigureResetStyle,
};
